var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJuno(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.917 52.917",
    height: "1em",
    width: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.913 26.529a26.399 26.41 0 01-26.399 26.41A26.399 26.41 0 01.115 26.528a26.399 26.41 0 0126.4-26.41 26.399 26.41 0 0126.398 26.41z",
    fill: "#1e1e1e",
    paintOrder: "stroke fill markers"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.538 4.819c-11.973 0-21.681 9.728-21.681 21.733s9.708 21.733 21.68 21.733c11.973 0 21.681-9.728 21.681-21.733 0-12.001-9.708-21.733-21.68-21.733zM2.658 26.552c0-13.223 10.693-23.937 23.88-23.937 13.186 0 23.879 10.719 23.879 23.937 0 13.223-10.693 23.937-23.88 23.937-13.186 0-23.878-10.714-23.878-23.937z",
    clipRule: "evenodd",
    fill: "#ff7b7c",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.964 20.849l-6.023-.251 4.093-4.443-1.649-1.649-4.436 4.09-.242-6.038h-2.326l-.25 6.039-4.432-4.104-1.645 1.653 4.085 4.447-6.028.238v2.336l6.023.251-4.093 4.443 1.649 1.648 4.366-4.028.193 9.784-3.486.256v2.173l3.54.269.065 3.398h2.326l.07-3.394 3.575-.273v-2.173l-3.522-.256.198-9.78 4.362 4.033 1.644-1.648-4.08-4.447 6.023-.243z",
    clipRule: "evenodd",
    fill: "#ff7b7c",
    fillRule: "evenodd"
  })));
}

export default SvgJuno;